<template>
    <v-layout row class="fill-height" style="padding-bottom:60px" >
        <v-flex md10 offset-md1 class="pr-3 pl-3">
          <div class="mt-4 mb-4" style="max-width:80%">
            <v-row>
              <v-col cols="1">
                <v-list-item-avatar>
                  <img :src="userOther.name?'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name='+userOther.name.replace(' ', '+')+'':''" >
                </v-list-item-avatar>
              </v-col>
              <v-col cols="11">
                <h2 style="margin-bottom: 8px;margin-top: 8px;">{{ userOther.name }}</h2>
              </v-col>
            </v-row>
          </div>
        </v-flex>
        <v-flex md10 offset-md1 style="overflow:auto;" class="pr-3 pl-3 forum"  ref="chatContainer">
          <div v-for="(chat, i) in CHATS"  :key="i" class="mt-4 mb-4 " style="max-width:80%">
            <app-chat-item :chat="chat"></app-chat-item>
          </div>
        </v-flex>
        <v-bottom-navigation :value="true" absolute color="blue">
          <v-layout>
            <app-chat-box></app-chat-box>
          </v-layout>
        </v-bottom-navigation>
    </v-layout>
</template>


<script>
import {mapGetters, mapMutations} from 'vuex'
import chatItem from '@/pages/chat/ChatItem'
import chatBox from '@/pages/chat/ChatBox'
import usuario from "@/services/usuario";
import message from "@/services/message";

export default {
  components: {
    appChatItem: chatItem,
    appChatBox: chatBox,
  },
  data () {
    return {
      path: '',
      user: {},
      userOther: {}
    }
  },
  // sockets : {
  //   connect: function(){
  //     console.log('salvarNotificacao connected');
  //   },
  //   chat: function(val){
  //     if (val.user1 == this.$route.params.id && val.user2 == this.$route.params.id2) {
  //       this.$store.dispatch("ADD_CHAT",val);
  //     }
  //   }
  // },
  computed:{
    ...mapGetters(['CHATS','HANDLE'])
  },
  watch: {
    '$route': async function (){
      await this.loadData();
    }
  },
  async created () {
    await this.loadData();
  },
  updated(){
    var container = this.$refs.chatContainer;
    container.scrollTop = container.scrollHeight;
  },
  methods: {
    async loadData () {
      this.setLoading(true);
      if (this.$route.params.id && this.$route.params.id2) {
        let uid1 = this.$route.params.id;
        let uid2 = this.$route.params.id2;
        this.user = await usuario.getUsuario(this.$store.getters.user._id);
        
        this.path = uid1 < uid2 ? uid1 + '/' + uid2 : uid2 + '/' + uid1;
        let handle = {
          user1: uid1 < uid2 ? uid1: uid2,
          user2: uid1 < uid2 ? uid2 : uid1,
          handle: this.user._id,
          name: this.user.name
        }
        this.$store.dispatch("SET_HANDLE",handle);
        
        if (this.$store.getters.user._id != uid1) {
          this.userOther = await usuario.getUsuario(uid1);
        } else {
          this.userOther = await usuario.getUsuario(uid2);
        }
        await message.salvarNotificacao({
          user1: uid1 < uid2 ? uid1: uid2,
          user2: uid1 < uid2 ? uid2 : uid1,
          handle: this.userOther._id,
          count: 0
        });

        this.$store.dispatch("SET_USUARIOS", this.user);
        this.$store.dispatch("SET_CHAT", {
          path: this.path
        });
      }
      this.setLoading(false);
    },
    ...mapMutations({
      setLoading : "setLoading",
    })
  }
}

</script>

<style>
html,body{
  height: 100%
}
.forum {
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  vertical-align: top;
  display: inline-block;
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/chat/Chat.vue